import React from 'react';
import { CopyLinkActionProps, CopyLinkActionType } from '../../types';
import { CopySavedViewLinkAction } from './CopySavedViewLinkAction';

export type CopyLinkButtonProps<TViewState extends object> = Omit<CopyLinkActionProps<TViewState>, 'actionType'> & {
  showIconOnly?: boolean;
};

export function CopySavedViewLinkButton<TViewState extends object>({
  showIconOnly,
  ...otherProps
}: CopyLinkButtonProps<TViewState>): JSX.Element {
  return (
    <CopySavedViewLinkAction
      {...otherProps}
      actionType={showIconOnly ? CopyLinkActionType.ButtonIconOnly : CopyLinkActionType.Button}
    />
  );
}
